// removed by extract-text-webpack-plugin
module.exports = {"list":"list__Q45mE"};


//////////////////
// WEBPACK FOOTER
// ./components/Faq/style.css
// module id = kZ5E
// module chunks = 0